<template>
  <div>
    <slot v-bind="{ showDispatch, showDispatchAll, toggleDispatchPartially }"></slot>
  </div>
</template>

<script>
export default {
  props: {
    amountInputId: String,
    checkboxInputId: String,
    amount: Number
  },
  data () {
    return {
      dispatchPartially: null
    }
  },
  computed: {
    amountInput() {
      return this.$formValues[this.amountInputId]
    },
    showDispatch() {
      return !((this.$formValues[this.amountInputId] === 0 || (this.$formValues[this.amountInputId] === this.amount && this.$formValues[this.checkboxInputId])) && !this.dispatchPartially)
    },
    showDispatchAll() {
      return this.$formValues[this.amountInputId] === 0 && !this.dispatchPartially
    },
  },
  watch: {
    amountInput (newVal, oldVal) {
      if ( parseInt(newVal) !== parseInt(oldVal) ) {
        this.$formValues[this.checkboxInputId] = false
      }
    }
  },
  methods: {
    toggleDispatchPartially() {
      this.dispatchPartially = !this.dispatchPartially
    }
  }
}
</script>
